// bwip-js (~0.9 MB) is only needed on the printing pages: loaded on demand it
// becomes its own chunk instead of weighing on every page of the main bundle.
let bwipJs;
export const loadBwipJs = () => {
    if (!bwipJs) {
        bwipJs = import('bwip-js')
            .then(module => module.default || module)
            .catch(error => { bwipJs = undefined; throw error; });
    }
    return bwipJs;
};
